import { type TypedDocumentNode, gql } from '@apollo/client';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import {
  AndroidAppFeature,
  IOsAppFeature,
  NotMobileAppFeature,
  UnvailableButtonForAndroid,
} from '@sorare/core/src/components/BuyableFeature';

import BidField from 'components/buyActions/BidField';

import { AuctionReminder } from '../AuctionReminder';
import { AuctionsActions_auction } from './__generated__/index.graphql';

type Props = { auction: AuctionsActions_auction };

export const AuctionsActions = ({ auction }: Props) => {
  return (
    <>
      <NotMobileAppFeature>
        <Horizontal>
          <AuctionReminder color="quaternary" auction={auction} small />
          <BidField color="quaternary" variant="small" auction={auction} />
        </Horizontal>
      </NotMobileAppFeature>
      <AndroidAppFeature>
        <Horizontal>
          <UnvailableButtonForAndroid color="tertiary" size="small" fullWidth />
        </Horizontal>
      </AndroidAppFeature>
      <IOsAppFeature>
        <AuctionReminder color="quaternary" auction={auction} withText small />
      </IOsAppFeature>
    </>
  );
};

AuctionsActions.fragments = {
  auction: gql`
    fragment AuctionsActions_auction on TokenAuction {
      id
      ...BidField_auction
      ...AuctionReminder_auction
    }
    ${BidField.fragments.auction}
    ${AuctionReminder.fragments.auction}
  ` as TypedDocumentNode<AuctionsActions_auction>,
};
